import { GrpcLibService, GrpcLibServiceOption } from '../grpc-lib.service';
import { UserLibService } from '../../user/user-lib.service';
import { StorageLibService } from '../../storage/storage-lib.service';
import { Injectable } from '@angular/core';
import { LeaderboardConversionService } from '../../conversion/leaderboard/leaderboard-conversion.service';
import { Leaderboard, Empty } from 'src/app/libs/proto/commUnity_pb';
import { Observable } from 'rxjs';
import * as grpcWeb from 'grpc-web';

@Injectable({
  providedIn: 'root'
})
export class GrpcLeaderboardLibService{
  constructor(
    private grpcLib: GrpcLibService,
    private userLib: UserLibService,
    private storLib: StorageLibService,
    private convLib: LeaderboardConversionService,
  ) { }

  getLeaderboard(option?: GrpcLibServiceOption): Promise<Leaderboard[]>{
    return new Observable<Leaderboard[]>(obs => {
      const opt = this.grpcLib.getOption(option);
      opt.call.subscribe = obs;

      if (!this.grpcLib.Data.online || (opt.Offline || false)) {
        this._getLeaderboardOffline(opt);
      } else {
        this._getLeaderboardOnline(opt);
      }
    }).toPromise();
  }

  private _getLeaderboardOffline(option: GrpcLibServiceOption){
    this.convLib.FromStorages(
      (this.storLib.get('leaderboard')), (ns, e) => {
        if (e == null) {
          if ((option.call.req || '') !== ''){
            if (ns) {
              option.call.subscribe.next( ns.filter( n => {
                return n.getId() === option.call.req;
              }));
              option.call.subscribe.complete();
              return;
            }
          }
        }

        option.call.subscribe.next(ns || []);
        option.call.subscribe.complete();
    });
  }

  private _getLeaderboardOnline(option: GrpcLibServiceOption){
    this.grpcLib.MobileClient.getLeaderBoard(new Empty(), {
        token: this.userLib.Data.token?.getToken()
      })
      .on('error', (e: grpcWeb.RpcError) => {
        this._getLeaderboardOnlineError(e, option);
      })
      .on('status', (s: grpcWeb.Status) => {
        this._getLeaderboardOnlineStatus(s, option);
      })
      .on('data', (r: Leaderboard) => {
        this._getLeaderboardOnlineData(r, option);
      })
      .on('end', () => {
        this._getLeaderboardOnlineEnd(option);
      });
  }

  private _getLeaderboardOnlineData(ret: Leaderboard, option: GrpcLibServiceOption) {
    option.call.data.push(ret);
  }

  private _getLeaderboardOnlineError(e: grpcWeb.RpcError, option: GrpcLibServiceOption) {
    const thise = this;

    this.grpcLib.handleError(e, () => {
      thise._getLeaderboardOnline(option);
    }, option);
  }

  private _getLeaderboardOnlineEnd(option: GrpcLibServiceOption) {
    option.call.subscribe.complete();
  }

  private _getLeaderboardOnlineStatus(s: grpcWeb.Status, option: GrpcLibServiceOption) {
    if (s.code === 0) {
      this.storLib.cache.leaderboard = true;
      if (option.KeepInCache || false) {
        this.storLib.set(
          'leaderboard', this.convLib.ToStorages(option.call.data)
        );
      }

      option.call.subscribe.next(option.call.data);
      if (option?.callback) { option?.callback(option.call.data); }

    } else {
      this.grpcLib.treatStatus(s, () => {
        this._getLeaderboardOnline(option);
      }, option);
    }
  }


}
